import { render, staticRenderFns } from "./VideoStudy.vue?vue&type=template&id=23bd2bb9&scoped=true"
import script from "./VideoStudy.vue?vue&type=script&lang=js"
export * from "./VideoStudy.vue?vue&type=script&lang=js"
import style0 from "./VideoStudy.vue?vue&type=style&index=0&id=23bd2bb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bd2bb9",
  null
  
)

export default component.exports